<template>
    <div class="m-top">
        <!-- logo -->
        <div class="m-top__logo">
            <img loading="lazy" src="@/assets/logo.png" alt="Debai Wood">
        </div>

        <!-- 语言切换 + 汉堡菜单 -->
        <div class="m-top__actions">
            <el-dropdown trigger="click" @command="handleSelectLang" class="m-lang">
                <span class="m-lang__text">
                    {{ currentLang.name }}<i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                        v-for="item in languageList"
                        :key="item.label"
                        :command="item.label">
                        {{ item.name }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <i v-if="currentMenuStatus===1" class="el-icon-s-fold m-menu-icon" @click="btnSwitch(2)"></i>
            <i v-else class="el-icon-close m-menu-icon" @click="btnSwitch(1)"></i>
        </div>

        <!-- 抽屉菜单 -->
        <el-drawer
            size="78%"
            :with-header="false"
            :visible.sync="drawerStatus"
            direction="rtl" custom-class="m-drawer"
            :before-close="closeDrawer"
            @closed="onDrawerClosed">
            <div class="m-drawer__head">
                <img loading="lazy" src="@/assets/logo.png" alt="Debai Wood" class="m-drawer__logo">
                <span class="m-drawer__brand">Debai Wood</span>
            </div>
            <div class="m-drawer__list">
                <div v-for="item in menuList" :key="item.id"
                     @click="btnChange(item)"
                     :class="['m-drawer__item', {'is-active': isActive(item.path)}]">
                    {{ item.name }}
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    name: 'MobileTop',
    created() {
        this.loadMenuList();
        const code = sessionStorage.getItem("lang") || 'en-US';
        const item = this.languageList.find(i => i.label === code);
        if (item) this.currentLang = item;
    },
    data() {
        return {
            languageList: [
                {label: "zh-CN", name: "中文"},
                {label: "en-US", name: "English"},
                {label: "es-ES", name: "Español"},
                {label: "ar-SA", name: "العربية"},
                {label: "ru-RU", name: "Русский"},
                {label: "pt-PT", name: "Português"},
            ],
            currentLang: {label: 'en-US', name: 'English'},
            // 当前导航栏状态 1:收起 2:展开
            currentMenuStatus: 1,
            drawerStatus: false,
            // 仅当由抽屉内菜单触发导航时，关闭抽屉后才回顶（避免单纯关抽屉也回顶）
            pendingScrollFromDrawer: false,
            menuList: [
                {id: 0, name: this.$t('header_menu.home'), path: "/"},
                {id: 1, name: this.$t('header_menu.about'), path: "/about"},
                {id: 2, name: this.$t('header_menu.product'), path: "/productsType"},
                {id: 3, name: this.$t('header_menu.news'), path: "/news"},
                {id: 4, name: this.$t('header_menu.download'), path: "/download"},
                {id: 5, name: this.$t('header_menu.contact'), path: "/concat"},
            ],
        }
    },
    methods: {
        /* 选择语言后回调 */
        handleSelectLang(lang) {
            const item = this.languageList.find(i => i.label === lang)
            if (item) {
                this.currentLang = item
                this.$i18n.locale = lang;
                sessionStorage.setItem("lang", lang);
                // 先回到顶部再整页 reload，避免停在页面下方
                window.scrollTo(0, 0);
                window.location.reload();
            }
        },
        // 切换导航栏
        btnSwitch(status) {
            this.currentMenuStatus = status;
            this.drawerStatus = !this.drawerStatus;
        },
        // 关闭导航栏
        closeDrawer() {
            this.currentMenuStatus = 1;
            this.drawerStatus = !this.drawerStatus;
        },
        loadMenuList() {
        },
        // 切换菜单
        btnChange(item) {
            this.pendingScrollFromDrawer = true;
            this.$router.push(item.path);
            this.btnSwitch(1);
        },
        // 抽屉完全关闭后兜底回顶：等 lock-scroll 释放、overflow 还原后再滚动，
        // 避免 el-drawer 锁滚动干扰 scrollBehavior 导致切换菜单不回顶
        onDrawerClosed() {
            if (!this.pendingScrollFromDrawer) return;
            this.pendingScrollFromDrawer = false;
            window.scrollTo(0, 0);
            const main = document.querySelector('.el-main');
            if (main) main.scrollTop = 0;
        },
        // 当前路由是否命中该菜单（产品子页也能高亮"Products"）
        isActive(path) {
            const cur = this.$route.path;
            if (path === '/') return cur === '/';
            return cur.startsWith(path);
        }
    }
}
</script>
<style scoped lang="scss">
.m-top {
    height: 56px;
    background: #fff;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;

    &__logo img {
        height: 34px;
        display: block;
    }
    &__actions {
        display: flex;
        align-items: center;
    }
}
.m-lang__text {
    font-size: 14px;
    color: var(--text);
    cursor: pointer;
    margin-right: 14px;

    i {
        margin-left: 2px;
        font-size: 12px;
        color: var(--muted);
    }
}
.m-menu-icon {
    font-size: 26px;
    color: var(--brand);
    cursor: pointer;
}

/* 抽屉 */
.m-drawer__head {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 56px;
    padding: 0 18px;
    background: linear-gradient(135deg, var(--brand-dark), var(--brand));
    color: #fff;

    .m-drawer__logo {
        height: 30px;
    }
    .m-drawer__brand {
        font-size: 16px;
        font-weight: 700;
        letter-spacing: .5px;
    }
}
.m-drawer__list {
    padding: 8px 0;
}
.m-drawer__item {
    padding: 15px 18px;
    font-size: 16px;
    color: var(--text);
    border-bottom: 1px solid #f0f0f0;
    transition: color .2s, padding-left .2s;

    &.is-active {
        color: var(--brand);
        font-weight: 700;
        padding-left: 22px;
        border-left: 3px solid var(--brand);
    }
}
</style>
